import {FC} from 'react';
import clsx from 'clsx';
import {shallowEqual} from 'react-redux';

import {useSelector} from '~/store/hooks';

import MainLogo from '../../MainLogo';
import HeaderMenu from '../../HeaderMenu';
import s from '../styles.module.scss';

const PersonalAreaContent: FC = () => {
  const {impersonate, mail, balance, isDisplayBalance} = useSelector(
    ({app, profile}) => ({
      impersonate: app.data.impersonate,
      mail: app.data.mail,
      balance: profile.data?.balance.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      isDisplayBalance: app.data.balance.display,
    }),
    shallowEqual
  );

  return (
    <div className={clsx(s['header-root'], s['personal-area-header'])}>
      <MainLogo variant="small" />
      <HeaderMenu
        impersonate={impersonate}
        mail={mail}
        balance={isDisplayBalance && balance ? balance : undefined}
        notifyButtonClassName={s['notify-button']}
      />
    </div>
  );
};

export default PersonalAreaContent;
